var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8877 8.75233L14.097 16.3321L14.097 1.17259L3.8877 8.75233Z",
    fill: "#F4F4F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.25,
    width: 1.94464,
    height: 15.004,
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardIcon);
export default __webpack_public_path__ + "static/media/BackwardIcon.fced33c58dd25a717f39f29dfb644d23.svg";
export { ForwardRef as ReactComponent };